import React, { useEffect, useState } from 'react'
import List from '../../components/List'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getJackpotHistory } from '../../services/jackpotHistory'
import { Tag } from 'antd'
import { onlyNumbers } from '../../utils/formValidation'
import { compareDates, compareNegativeCurrency, stringCompare, transformToNumberAndCompare } from '../../utils/sorters'
import { sendSystemLog } from '../../context/AuthProvider/useAuth'

export interface IJackpotHistoryItem {
  id:string,
  historyId:string,
  roundId:string,
  templateId:string,
  state:string,
  gameIds:number,
  type:string,
  name:string,
  pct:number,
  contrib:string,
  seed:string,
  addition:string,
  totalPrize:string,
  winners:string,
  start:string,
  end:string
}


function index() {
  const loading = useLoading()
  
  const [jackpotHistory, setjackpotHistory] = useState<IJackpotHistoryItem[]>([])

  const log = {
    log_type: 'visited',
    log_object: 'bingo_game_jackpot_history'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])



  useEffect(()=> {
    (async() => {
      loading.addLoading()
      const res = await getJackpotHistory()
      setjackpotHistory(res)
      loading.removeLoading()
    })()
  },[])

  return (
    <div className="jackpot-history">
      <List
        rows={jackpotHistory}
        columns={[
          {
            title: <>History ID<br/> Template ID<br/>  Round ID</>,
            dataIndex: 'historyId',
            key: 'historyId',
            render: (value: string, record: IJackpotHistoryItem) => (
              <>
                {record.historyId}<br/>
                {record.templateId}<br/>
                {record.roundId}<br/>
              </>
            ),
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => stringCompare(a.historyId, b.historyId),
            width: 150
          },
          {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
            render: (value: string) => <Tag color={value === 'won' ? 'green' : 'red'}>{value}</Tag>,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => stringCompare(a.state, b.state),
            width: 110
          },
          {
            title: 'Game IDs',
            dataIndex: 'gameIds',
            key: 'gameIds',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => a.gameIds - b.gameIds,
            width: 80
          },
          {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => stringCompare(a.type, b.type),
            width: 120
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => stringCompare(a.name, b.name),
            width: 100
          },
          {
            title: 'Pct',
            dataIndex: 'pct',
            key: 'pct',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => a.pct - b.pct,
            width: 80
          },
          {
            title: 'Contrib',
            dataIndex: 'contrib',
            key: 'contrib',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => transformToNumberAndCompare(a.contrib, b.contrib),
            width: 100
          },
          {
            title: 'Seed',
            dataIndex: 'seed',
            key: 'seed',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => transformToNumberAndCompare(a.seed, b.seed),
            width: 100
          },
          {
            title: 'Addition',
            dataIndex: 'addition',
            key: 'addition',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) =>  compareNegativeCurrency(a.addition, b.addition),
            width: 100
          },
          {
            title: 'Total Prize',
            dataIndex: 'totalPrize',
            key: 'totalPrize',
            render: (value: string) => <Tag color={value !== '$0.00' ? 'green' : 'red'}>{value}</Tag>,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => transformToNumberAndCompare(a.totalPrize, b.totalPrize),
            width: 100
          },
          {
            title: 'Winners',
            dataIndex: 'winners',
            key: 'winners',
            render: (value: string) => value,
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => stringCompare(a.winners, b.winners),
            width: 150
          },
          {
            title: 'Start/End',
            dataIndex: 'start',
            key: 'start',
            render: (value: string, record:IJackpotHistoryItem) => (
              <>
                {record.start}<br/>
                {record.end}<br/>
              </>
            ),
            sorter: (a: IJackpotHistoryItem, b: IJackpotHistoryItem) => compareDates(a.start, b.start, 'YYYY-MM-DD HH:mm:ss'),
            width: 200
          },
        ]}
      />
    </div>
  )
}

export default index